import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Partner extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get name() {
    return get(this, '_nazwa.value', '');
  }

  get logo() {
    return get(this, '_logo.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Partner.model.js